import { cognitoApi } from '../cognitoApi';
import { CognitoAPIResponse } from '../types';
import { attachIds } from '../utils';

import {
  EnrolmentSnapshot, StudentSnapshot,
} from './types';

// Define a service using a base URL and expected endpoints
export const snapshotsApi = cognitoApi.injectEndpoints({
  endpoints: (build) => ({
    getStudentSnapshots: build.query<CognitoAPIResponse<StudentSnapshot[]>, {
      startDatetime?: number,
      endDatetime?: number
    }>({
      query(arg) {
        const { startDatetime, endDatetime } = arg;

        return {
          url: 'snapshots/students',
          params: { startDatetime, endDatetime },
          method: 'GET',
        };
      },
      providesTags: (result) => (result
        ? [...result.data.map(({ id }) =>
          ({ type: 'StudentSnapshots' as const, id })), 'StudentSnapshots']
        : ['StudentSnapshots']),
      transformResponse(response: any) {
        return attachIds(response, (entry) => entry.datetime);
      },
    }),
    getEnrolmentSnapshots: build.query<CognitoAPIResponse<EnrolmentSnapshot[]>, {
      startDatetime?: number,
      endDatetime?: number
    }>({
      query(arg) {
        const { startDatetime, endDatetime } = arg;

        return {
          url: 'snapshots/enrolments',
          params: { startDatetime, endDatetime },
          method: 'GET',
        };
      },
      providesTags: (result) => (result
        ? [...result.data.map(({ id }) =>
          ({ type: 'EnrolmentSnapshots' as const, id })), 'EnrolmentSnapshots']
        : ['EnrolmentSnapshots']),
      transformResponse(response: any) {
        return attachIds(response, (entry) => entry.datetime);
      },
    }),
  }),
});

export const {
  useGetStudentSnapshotsQuery,
  useGetEnrolmentSnapshotsQuery,
} = snapshotsApi;
